module.exports = __webpack_public_path__ + "static/media/3-1.ba2f945b.mp3";